module.exports = __webpack_public_path__ + "img/community.917fc2fe.svg";